import { ICardModel, ICardUIExtensionContext } from 'tessa/ui/cards';
import { PkCommonHelper } from './PkCommonHelper';
import { Card, CardPermissionFlags, CardSection, CardRowState, CardRow } from 'tessa/cards';
import { hasFlag, Guid, createTypedField, DotNetType } from 'tessa/platform';
import { isNullOrUndefined } from 'util';
import { CdUIHelper } from 'src/cdScripts/UI/CdUIHelper';
import { GridViewModel } from 'tessa/ui/cards/controls';
import { showError, UIButton } from 'tessa/ui';
import { CdCardTypes } from 'src/cdScripts/Helpers/CdCardTypes';
import {  reaction } from 'mobx';
import { ArrayStorage } from 'tessa/platform/storage';
import { CardRequest, CardService } from 'tessa/cards/service';
import { CdRequestTypes } from 'src/cdScripts/Helpers/CdRequestTypes';
import { ChRequestTypes } from './ChRequestTypes';

export class PkClientHelper {

    /**Подписаться на изменения поля в коллекционной секции
     *  Если строка добавилась или удалилась, то в CardFieldChangedEventArgs приходит Null.
     *  Если изменилось поле, то из CardFieldChangedEventArgs можно достать FieldName.
     *  Если строки чистятся не через изменение состояния, то подписка не работает, это нужно будет дописывать
     * 
    */
    public static SubscribeForFieldChanging(colection: CardSection, callback: any) {
        colection.rows.forEach(row => {
            row.fieldChanged.add((args) => { callback(args); });
            row.stateChanged.add(() => { callback(null); });
        });

        colection.rows.collectionChanged.add(e => {
            if (isNullOrUndefined(e.added)) {
                return;
            }
            e.added.forEach(item => {
                item.fieldChanged.add(e1 => { callback(e1); });
                item.stateChanged.add(() => { callback(null); });
            })
            callback(null, null);
        });
    }

    public static GetVatValue(vatRateCaption: string): number {
        let vatValue = 0;
        if (vatRateCaption === "НДС0") {
            vatValue = 0;
        }
        if (vatRateCaption === "НДС10") {
            vatValue = 10;
        }
        if (vatRateCaption === "НДС18") {
            vatValue = 18;
        }
        if (vatRateCaption === "НДС20") {
            vatValue = 20;
        }
        if (vatRateCaption === "БезНДС") {
            vatValue = 0;
        }
        return vatValue;
    }

    public static SetReadonlyContractWhileFieldIsNull(
        model: ICardModel,
        card: Card,
        contractSection: string,
        contractField: string,
        checkedField1: string,
        checkedField2: string | null,
        checkedSection1: string | null,
        checkedSection2: string | null,
        controlName: string | "Contract") {
        // Если секция 1 не заполнена
        if (PkCommonHelper.IsNullOrWhitespace(checkedSection1)) {
            checkedSection1 = contractSection;
        }
        // Если нет секции 2, записываем в неё значение секции 1
        if (PkCommonHelper.IsNullOrWhitespace(checkedSection2)) {
            checkedSection2 = checkedSection1;
        }
        // Если нет поля 2, то записываем значения секции и поля 1
        if (PkCommonHelper.IsNullOrWhitespace(checkedField2)) {
            checkedSection2 = checkedSection1;
            checkedField2 = checkedField1;
        }
        let checkedSection1Sect;
        let checkedSection2Sect;
        if (checkedSection1 != null && (checkedSection1Sect = card.sections.tryGet(checkedSection1)) != null &&
            checkedSection2 != null && (checkedSection2Sect = card.sections.tryGet(checkedSection2)) != null) {
            const isFieldProhipit = hasFlag(model.card.permissions.resolver
                .getFieldPermissions(contractSection, contractField + "ID"), CardPermissionFlags.ProhibitModify);

            if (checkedSection1Sect.fields.tryGet(checkedField1) != null &&
                checkedSection2Sect.fields.tryGet(checkedField2) != null) {
                const control = model.controls.get(controlName);
                if (control && !isFieldProhipit) {
                    control.isReadOnly = false;
                }
            }

            // Отслеживаем изменения в полях
            checkedSection1Sect.fields.fieldChanged.add(e => {
                if (e.fieldName === null) return;

                if (checkedSection1Sect.fields.tryGet(checkedField1) != null &&
                    checkedSection2Sect.fields.tryGet(checkedField2) != null) {
                    const control = model.controls.get(controlName);
                    if (control && !isFieldProhipit) {
                        control.isReadOnly = false;
                    }
                }
                else {
                    let contractSectionSect;
                    if ((contractSectionSect = card.sections.tryGet(contractSection)) != null) {
                        contractSectionSect.fields.set(contractField + "ID", null);
                        contractSectionSect.fields.set(contractField + "NameVirtual", null);

                        const control = model.controls.get(controlName);
                        if (control) {
                            control.isReadOnly = true;
                        }
                    }
                }
            });

            // Если поле одно и то же, то не добавляем обработку
            if (checkedSection1 !== checkedSection2 && checkedField1 !== checkedField2) {
                checkedSection2Sect.fields.fieldChanged.add(e => {
                    if (e.fieldName === null) return;

                    if (checkedSection2Sect.fields.tryGet(checkedField2) != null &&
                        checkedSection1Sect.fields.tryGet(checkedField1) != null) {

                        const control = model.controls.get(controlName);
                        if (control && !isFieldProhipit) {
                            control.isReadOnly = false;
                        }
                    }
                    else {
                        let contractSectionSect;
                        if ((contractSectionSect = card.sections.tryGet(contractSection)) != null) {
                            contractSectionSect.fields.set(contractField + "ID", null);
                            contractSectionSect.fields.set(contractField + "NameVirtual", null);

                            const control = model.controls.get(controlName);
                            if (control) {
                                control.isReadOnly = true;
                            }
                        }
                    }
                });
            }
        }
    }

    public static GetFieldValue(card: Card, sectionName: string, fieldName: string): any
    {
        let section = card.sections.tryGet(sectionName);
        let field = section?.fields.tryGetField(fieldName)?.$value ?? null;
        return field;
    }

    /** Подсчет суммы по стикерам. */
    public static SumStickerAmount(filterStickerRows: CardRow[] | ArrayStorage<CardRow>, amountFieldName: string): number {
        let outsum: number = 0.0;
        for (let stickerArticle of filterStickerRows) {
            let amount = stickerArticle.getField(amountFieldName)?.$value;
            if (amount != null) {
                outsum += Number.parseFloat(amount);
            }
        }
        return outsum;
    }


    public static ClearSection(section: CardSection) {
        // чистим
        for (let i = section!.rows.length - 1; i >= 0; i--) {
            let row = section!.rows[i];
            if (row.state !== CardRowState.Inserted) {
                row.state = CardRowState.Deleted;
            } 
            else {
                section!.rows.remove(row);
            }
        }
    }
    
    /* проверка был ли контрагент когда либо в Периметре.
    */
    public static async CheckPartnerInPerimeterAsync(partnerExternalID: number | null, аccreditationPerimetrName: string, everBeen : boolean = false) {

        if (!partnerExternalID) {
            return false;
        }

        const request = new CardRequest();
        request.requestType = CdRequestTypes.CheckPartnerInPerimeter;
        request.info["PartnerExternalID"] = createTypedField(partnerExternalID, DotNetType.Int64);
        request.info["AccreditationPerimetrName"] = createTypedField(аccreditationPerimetrName, DotNetType.String);
        request.info["EverBeen"] = createTypedField(everBeen, DotNetType.Boolean);

        const response = await CardService.instance.request(request);
        if (!response.validationResult.isSuccessful)
            return false;

        let error = response.info.Error?.$value;
        if (error) {
            await showError(error);
            return false;
        }

        let res: boolean = response.info.IsPartnerInPerimeter.$value;
        return res;

    }

    public static async IsUserInRoleAsync(userId : guid, roleID : guid)
    {
        const request = new CardRequest();
        request.requestType = ChRequestTypes.CheckUserInRole
        request.info["UserID"] = createTypedField(userId, DotNetType.Guid);
        request.info["RoleID"] = createTypedField(roleID, DotNetType.Guid);

        const response = await CardService.instance.request(request);

        if (response.validationResult.build().isSuccessful)
        {
            return response.info.IsUserInRole.$value;
        }
        
        return false
    }
}
/* * Кнопка для копирования строк в коллекционной секции*/
export class ButtonForCopyingRows {
   
    /** Название грида, для которго добавляется кнопка*/
    private gridName: string;

    /** Название секции, к которой привязан грид*/
    private sectionName: string;

    /**
     * * @param gridName Название грида для которго добавляется кнопка
     * * @param gridName Название секции, к которой привязан грид
    */
    public constructor(gridName: string, sectionName: string) {
        this.gridName = gridName;
        this.sectionName = sectionName;
    }

    public Initialized(context: ICardUIExtensionContext) {
        ButtonForCopyingRows.Initialized(context, this.gridName, this.sectionName);
    }

    
    /** Доступность кнопки снятия выделения строк. */
    private static IsEnabledCopyFunc(context: ICardUIExtensionContext, grid: GridViewModel) {
        return (((context.card.permissions.cardPermissions & CardPermissionFlags.AllowModify)!=0 || !Guid.equals(context.card.typeId, CdCardTypes.PkRequestForMaterialsTypeID) ) 
            && grid!.selectedRows.length>0 );}
    
  


    /** Инициализировать кнопку копировать для грида
     * * @param gridName Название грида, для которго добавляется кнопка
     * * @param gridName Название секции, к которой привязан грид
     */
    public static Initialized(context: ICardUIExtensionContext, gridName: string, sectionName: string, sortingField?: string) {
        const grid = CdUIHelper.GetUIControl<GridViewModel>(context, gridName);
        const section = context.card.sections.get(sectionName)!;
        const rowsModel = section.rows;
        const b = new UIButton(
            "Копировать строку",
            () => {
                grid!.selectedRows.forEach(cardRowViewModel => {
                    let sourceRow = cardRowViewModel.row;
                    let newRow = rowsModel.add();
                    for (let keyValuePair of sourceRow) {
                        let copy = keyValuePair[1]!;
                        newRow.set(keyValuePair[0], copy);
                    }
                    if (sortingField)
                    {
                        newRow.set(sortingField,createTypedField(grid!.rows.length, DotNetType.Int32) );
                    }
                    newRow.rowId = Guid.newGuid();
                    newRow.state = CardRowState.Inserted
                });
            }
        );
        let disposer: Function | null = null;
        b.setIsEnabled(this.IsEnabledCopyFunc(context,grid!));
        if (disposer == null) {         
            disposer =  reaction(() => grid!.selectedRows, () => {
              b.setIsEnabled(this.IsEnabledCopyFunc(context,grid!));
            });
        }
     
        grid!.rightButtons.push(b);
        return disposer;        
    }

    /** Копировать все поля из одной строки в другую */
    public static CopyRow(sourceRow: CardRow, newRow: CardRow) {
        for (let keyValuePair of sourceRow) {
            let copy = keyValuePair[1]!;
            newRow.set(keyValuePair[0], copy);
        }
    }
}